
// export default OfferNewsList;
import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Snackbar } from "@mui/material";


function OfferNewsList() {
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true); // Loader state
  const [open, setOpen] = useState(false); // Modal state
  const [allData, setAllData] = useState([]); 
  const [selectedItem, setSelectedItem] = useState(null);
  const [formData, setFormData] = useState({text: "", type: ""  });
  const [newFormData, setNewFormData] = useState({ type: "", text: "" });
  const userRole = localStorage.getItem("userRole"); // Fetch user role from localStorage
  const [addOpen, setAddOpen] = useState(false); // Add modal state
 const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");
  const [deleteBox, setdeleteBox] = useState(false); // Modal state

  const [filterType, setFilterType] = useState(""); // State for filter by type
  const [openFilter, setOpenFilter] = useState(false);
  useEffect(() => {
    fetchData();
  }, []); // Fetch data only once on component mount

  // Apply filters to the data
const applyFilters = (data) => {
  const filteredRows = data
    .filter((item) => !filterType || item.type === filterType) // Filter by type
    .map((item, index) => ({
      srNo: index + 1,
      type: item.type === "NEWS" ? "ANNOUNCEMENT" : item.type || "N/A",
      text: item.text || "N/A",
      actions: (
        <MDBox display="flex" justifyContent="center">
          <IconButton
            color="primary"
            size="small"
            onClick={() => handleEdit(item)}
          >
            <EditIcon style={{ color: "green" }} />
          </IconButton>
          {userRole === "SUPER_ADMIN" && (
            <IconButton
              color="secondary"
              size="small"
              onClick={() => handleConfirmDelete(item)}
            >
              <DeleteIcon style={{ color: "red" }} />
            </IconButton>
          )}
        </MDBox>
      ),
    }));

  // Define table columns
  const columns = [
    { Header: "Sr. No", accessor: "srNo", align: "center" },
    { Header: "Type", accessor: "type", align: "center" },
    { Header: "Text", accessor: "text", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  setTableData({ columns, rows: filteredRows });
  setLoading(false); // Set loading to false after data is loaded
};

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
  
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return; // Exit if sessionToken is not found
      }
      const response = await axios.get(
        "https://api.exampladmedia.com/api/offerAndNews/getAllOfferAndNews",
        {
          headers: {
            Authorization: sessionToken,
          },
        }
      );
  
      const data = response.data.data;
      setAllData(data); // Store all fetched data
      applyFilters(data); // Apply filters to the data
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false); // Set loading to false even if there's an error
    }
  };

  useEffect(() => {
    if (allData.length > 0) {
      applyFilters(allData); // Re-apply filters when filterType changes
    }
  }, [filterType]); // Re-apply filters when filterType changes


  const handleConfirmDelete = async (item) => {
    setSelectedItem(item); // Set the item to be deleted

    setdeleteBox(true)
  }
  const handleDelete = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return; // Exit if sessionToken is not found
      }

      const response = await axios.delete(
        `https://api.exampladmedia.com/api/offerAndNews/remove/${selectedItem.offersAndNews}`,
        {
          headers: {
              Authorization: sessionToken,
 },
        }
      );

      if (response.status === 200) {
        setSnackbarMsg(response.data.message);
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        fetchData(); // Refresh data after deleting
      }
    } catch (error) {
      if (error.response) {
        setSnackbarMsg(error.response.data.error || "An error occurred.");
      } else {
        setSnackbarMsg("An error occurred. Please try again.");
      }

      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }

    setdeleteBox(false); // Close the dialog
  };

  // const handleDelete = async (item) => {
  //   const confirmed = window.confirm(
  //     `Are you sure you want to delete this ${item.type}?`
  //   );

  //   if (confirmed) {
  //     try {
  //       const sessionToken = localStorage.getItem("sessionToken");

  //       if (!sessionToken) {
  //         console.error("Session token not found. Please log in again.");
  //         return; // Exit if sessionToken is not found
  //       }
  //       const response = await axios.delete(
  //         `https://api.exampladmedia.com/api/offerAndNews/remove/${item.offersAndNews}`,
  //         {
  //           headers: {
  //             Authorization: sessionToken,
  //           },
  //         }
  //       );
  //       if (response.status === 200) {
  //         setSnackbarMsg(response.data.message);
  //         setOpenSnackbar(true);
  //         setTimeout(() => setOpenSnackbar(false), 2000);
  //      //   alert("Deleted successfully!");
  //         fetchData();
  //       }
  //     } catch (error) {
  //       // Handle errors gracefully
  //       if (error.response) {
  //        // console.error("Error updating data:", error.response.data.message || error.response.data);
  //         setSnackbarMsg(error.response.data.error || "An error occurred.");
  //       } else {
  //        // console.error("Error updating data:", error.message);
  //         setSnackbarMsg("An error occurred. Please try again.");
  //       }
    
  //       setOpenSnackbar(true);
  //       setTimeout(() => setOpenSnackbar(false), 2000);
  //     }
  //   }
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleEdit = (item) => {
    setSelectedItem(item); // Set item to edit
    setFormData({ type: item.type, text: item.text });
    setOpen(true); // Open modal
  };

  const handleAdd = () => {
    setNewFormData({ type: "", text: "" }); // Reset the Add form data
    setAddOpen(true); // Open add modal
  };

 
  const handleSave = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
  
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return; // Exit if sessionToken is not found
      }
  
      const response = await axios.put(
           `https://api.exampladmedia.com/api/offerAndNews/edit/${selectedItem.offersAndNews}`,

        formData,
        {
          headers: {
                   Authorization: sessionToken,

          },
        }
      );
  
      if (response.status === 200) {
        console.log("Offer updated:", response.data.message);
        setSnackbarMsg(response.data.message);
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
       

        fetchData(); 
         setOpen(false); // Close modal

      }
    } catch (error) {
      // Handle errors gracefully
      if (error.response) {
       // console.error("Error updating data:", error.response.data.message || error.response.data);
        setSnackbarMsg(error.response.data.error || "An error occurred.");
      } else {
       // console.error("Error updating data:", error.message);
        setSnackbarMsg("An error occurred. Please try again.");
      }
  
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };
  
  const handleClose = () => {
    setOpen(false);
  };
 
  const handleAddOffer = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return; // Exit if sessionToken is not found
      }
console.log(newFormData)
      const response = await axios.post(
        `https://api.exampladmedia.com/api/offerAndNews/add`,
        newFormData,
        {
          headers: {
            Authorization: sessionToken,
          },
        }
      );

      if (response.status === 201) {
        console.log("Offer updated:", response.data.message);
        setSnackbarMsg(response.data.message);
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        //alert("Offer/News added successfully!");
        setAddOpen(false); // Close modal
        fetchData(); // Refresh data
      }
    } catch (error) {
      // Handle errors gracefully
      if (error.response) {
       // console.error("Error updating data:", error.response.data.message || error.response.data);
        setSnackbarMsg(error.response.data.error || "An error occurred.");
      } else {
       // console.error("Error updating data:", error.message);
        setSnackbarMsg("An error occurred. Please try again.");
      }
  
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };
  
 
  const  handleDeleteCancel = () => {
    setdeleteBox(false)
  }

  

  return (
    <DashboardLayout>
     <MDBox pt={6} pb={3}>
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Card>
        
      <MDBox
  mx={2}
  mt={-3}
  py={3}
  px={2}
  variant="gradient"
  bgColor="info"
  borderRadius="lg"
  coloredShadow="info"
  display="flex"
  justifyContent="space-between"
  alignItems="center"
>
  {/* Add button aligned to the left */}
  <Button
    variant="contained"
    style={{
      backgroundColor: "white",
      color: "grey",
    }}
    onClick={handleAdd}
  >
    Add
  </Button>

  {/* Filter dropdown and Remove All Filters button */}
  {/* <MDBox display="flex" alignItems="center" gap={2}>
    <FormControl
      variant="outlined"
      size="small"
      sx={{
        minWidth: 120,
        backgroundColor: "white", // White background
        borderRadius: "8px",
      }}
    >
      <InputLabel sx={{ color: "black" }}>Filter by Type</InputLabel>
      <Select
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
        label="Filter by Type"
        sx={{
          backgroundColor: "white", // White background
          color: "black", // Black text color
          height: "40px", // Increase height of the dropdown button
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "grey", // Customize border color
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "black", // Change border color on hover
          },
        }}
      >
        <MenuItem value="">All</MenuItem>
        <MenuItem value="OFFERS">OFFERS</MenuItem>
        <MenuItem value="NEWS">NEWS</MenuItem>
      </Select>
    </FormControl>

  </MDBox> */}

<MDBox display="flex" alignItems="center" gap={2} pl={2}>
      {/* Filter Dropdown with Custom Arrow */}
      <FormControl
        variant="outlined"
        size="small"
        style={{
          marginLeft: "5px",
          minWidth: 120,
          backgroundColor: "white",
          borderRadius: "8px",
          position: "relative", // Ensure positioning for absolute arrow
        }}
      >
        <InputLabel style={{ color: "grey", paddingLeft: 1 }}>Filter by Type</InputLabel>
        <Select
          value={filterType}
          onChange={(e) => {
            setFilterType(e.target.value); // Set the filter value
            setOpenFilter(false); // Close the dropdown
          }}
          open={openFilter} // Control open state
          onClose={() => setOpenFilter(false)} // Close dropdown when clicking outside
          onOpen={() => setOpenFilter(true)} // Open dropdown
          style={{
            backgroundColor: "white",
            color: "black",
            height: "40px",
            padding: "8px",
          }}
        >
          <MenuItem value="" sx={{ paddingLeft: 2 }}>All</MenuItem>
          <MenuItem value="OFFERS" sx={{ paddingLeft: 2 }}>OFFERS</MenuItem>
          <MenuItem value="NEWS" sx={{ paddingLeft: 2 }}>ANNOUNCEMENTS</MenuItem>
        </Select>
        {/* Custom Arrow Button */}
        <IconButton
          onClick={(e) => {
            e.stopPropagation(); // Prevent event bubbling
            setOpenFilter((prev) => !prev); // Toggle open state
          }}
          sx={{
            position: "absolute",
            right: "2px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 2, // Ensure it stays clickable
          }}
        >
          <ArrowDropDownIcon />
        </IconButton>
      </FormControl>
    </MDBox>


  {/* Heading centered */}
  <h2 style={{ color: "white", margin: 0, flex: 1, textAlign: "center" }}>
    Add Offers & Announcements
  </h2>
</MDBox>

        <MDBox pt={3} px={3}>
          {loading ? (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="300px"
            >
              <CircularProgress color="info" />
            </MDBox>
          ) : (
            <DataTable
              table={tableData}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          )}
        </MDBox>
      </Card>
    </Grid>
  </Grid>
</MDBox>

      {/* add model */}
      <Dialog open={addOpen} onClose={() => setAddOpen(false)}>
        <DialogTitle> Add Offers & Announcements
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <TextField
              label="Text"
              name="text"
              value={newFormData.text}
              onChange={(e) =>
                setNewFormData({ ...newFormData, text: e.target.value })
              }
              fullWidth
              margin="normal"
            />
          </MDBox>
          <MDBox mb={2}>
            <FormControl fullWidth>
              <InputLabel id="type-label">Type</InputLabel>
              <Select
                labelId="type-label"
                value={newFormData.type}
                sx={{
                  height: "40px",
                }}
                onChange={(e) =>
                  setNewFormData({ ...newFormData, type: e.target.value })
                }
                label="Type"
              >
                <MenuItem value="OFFERS">OFFERS</MenuItem>
                <MenuItem value="NEWS">ANNOUNCEMENTS</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleAddOffer} style={{color:'green'}}>
            Save
          </Button>
          <Button onClick={() => setAddOpen(false)} style={{color:'red'}}>
            Close
          </Button>
         
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Offers & Announcements</DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <TextField
              label="Text"
              name="text"
              value={formData.text}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          </MDBox>
          <MDBox mb={2}>
            {/* <FormControl fullWidth>
              <InputLabel id="type-label">Type</InputLabel>
              <Select
                labelId="type-label"
                value={formData.type}
                sx={{
                  height: "40px",
                }}
                onChange={(e) =>
                  handleChange({
                    target: { name: "type", value: e.target.value },
                  })
                }
                label="Type"
               

              >
                <MenuItem value="OFFERS">OFFERS</MenuItem>
                <MenuItem value="NEWS">NEWS</MenuItem>
              </Select>
            </FormControl> */}
          </MDBox>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleSave} style={{color:'green'}}>
            Save
          </Button>
          <Button onClick={handleClose}  style={{color:'red'}}>
            Close
          </Button>
          
        </DialogActions>
      </Dialog>
       <Snackbar
              open={openSnackbar}
              message={SnackbarMsg}
              autoHideDuration={2000}
              anchorOrigin={{ vertical:"top", horizontal: "right" }}
      
              onClose={() => setOpenSnackbar(false)}
            />

            {/* deletion Dialogbox */}
            <Dialog open={deleteBox} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>
            Are you sure you want to delete this {selectedItem?.type || "item"}?
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} style={{ color: "green" }} >
            Confirm
          </Button>
          <Button onClick={handleDeleteCancel}style={{ color: "red" }} >
            Cancel
          </Button>
          
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default OfferNewsList;

